// Mock data for the dominatrix website - Mistress T-Rex Monroe

export const heroImages = [
  "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/qupxeihh_DSC08157~2.jpg",
  "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/rfksi8k5_DSC08245~2.jpg",
  "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/yd6kk2mz_DSC09639.jpg",
  "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/cd6p8a3g_DSC09641.jpg",
  "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/kmcrlns7_GPF_2820_0831.jpg",
  "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/dw4j889k_DSC09860.JPG",
  "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/kiawe8k4_P8046023.JPG"
];

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/qupxeihh_DSC08157~2.jpg",
    alt: "Mistress T-Rex Monroe"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/rfksi8k5_DSC08245~2.jpg",
    alt: "Professional Dominatrix"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/yd6kk2mz_DSC09639.jpg",
    alt: "Vancouver Dominatrix"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/cd6p8a3g_DSC09641.jpg",
    alt: "FemDom Sessions"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/kmcrlns7_GPF_2820_0831.jpg",
    alt: "BDSM Professional"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/dw4j889k_DSC09860.JPG",
    alt: "Mistress T-Rex"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/kiawe8k4_P8046023.JPG",
    alt: "Dominatrix Vancouver"
  },
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/sz7fcuyf_Q0010040-001.JPG",
    alt: "Professional Domme"
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/ro41xft0_IMG_E6573.JPG",
    alt: "T-Rex Monroe"
  }
];

export const logoUrl = "https://customer-assets.emergentagent.com/job_elegant-femdom/artifacts/58mz7lsw_Untitled%20design%20%285%29.png";

export const siteInfo = {
  name: "MISTRESS T-REX MONROE",
  tagline: "Professional Dominatrix",
  subtitle: "",
  location: "VANCOUVER"
};

export const aboutContent = {
  title: "I’ll Nurture You. I’ll Break You. Sometimes Both at Once",
  intro: "Surrender doesn’t have to be scary. With me, you’ll laugh, squirm, and if you’re well-behaved, discover how sweet obedience can be — but misstep, and you’ll feel my bite.",
  credentials: [
    "Certified Health Care Assistant (HCA)",
    "Reiki Master with nearly 20 years of experience",
    "Certified Trauma-Sensitive Yoga Instructor",
    "Certificate in Visual Arts"
  ],
  philosophy: `I am Mistress T-Rex Monroe, a professional dominatrix based in Vancouver, BC. I embody the paradox of power: nurturing yet merciless, playful yet precise, sadistic yet deeply attuned to those who kneel before me.

What sets me apart among Dommes is how my educational background informs and enhances my practice. I hold a BA in Psychology (Honours) with focused study in counseling skills, sexuality in older adults, and the therapeutic potential of psychedelics. My academic grounding gives me a rare depth of understanding in the complexities of human desire, vulnerability, and growth through power exchange.`
};

export const etiquette = {
  title: "ETIQUETTE & PROTOCOL",
  rules: [
    {
      title: "How to Address Me",
      description: "You may call me Mistress, Goddess, Mistress T-Rex, Empress, or My Queen."
    },
    {
      title: "Boundaries",
      description: "Other than for foot worship, and unless otherwise specified, you do not have my consent to touch me. Ever."
    },
    {
      title: "Booking Requirements",
      description: "Dungeon session bookings must be made at least 24 hours in advance, but one week or more is recommended to secure your desired appointment time. The space books up fast — plan ahead and don't miss out."
    },
    {
      title: "Deposits & Cancellations",
      description: "Deposits are required for all in-person sessions and are non-refundable. They can be applied to a future date if you reschedule at least 48 hours before your appointment. Rescheduling with less than 48 hours notice or failing to show forfeits your deposit."
    },
    {
      title: "Tips & Gifts",
      description: "While not mandatory, tips and gifts are always appreciated and reflect well on you as a submissive. You should value the opportunity to please me and contribute to my life."
    }
  ]
};

export const servicesData = {
  title: "IN-PERSON SESSIONS",
  description: "Experience an in-person session at an elegant, upscale, fully equipped dungeon, where privacy and cleanliness are a priority.",
  kinks: [
    "Trampling (with or without trampling table)",
    "Foot Worship",
    "CBT, Ball Kicking/Ball Busting",
    "Bondage, Imprisonment, Abandonment",
    "Impact (Flogging, Caning, Whipping, Barehanded)",
    "Chastity",
    "Sissification, Feminization, Sissy Play",
    "Pegging, Anal Training, Fisting",
    "Medical Play",
    "Pet Play",
    "Toilet Training",
    "SPH, JOI, CEI",
    "Facesitting (Covered)",
    "Encouraged Bi",
    "Findom"
  ],
  rates: [
    { name: 'Tribute Session', duration: '1 Hour', price: '$400' },
    { name: 'Extended Session', duration: '2 Hours', price: '$700' },
    { name: 'Half Day Experience', duration: '4 Hours', price: '$1,200' },
    { name: 'Virtual Domination', duration: '30 Min', price: '$150' },
    { name: 'Phone Domination', duration: '15 Min', price: '$75' }
  ]
};

export const testimonials = [
  {
    id: 1,
    text: "Thank you for tonight. It's hard to express just how grateful I am for people like yourself and these judgement-free zones you help create. For someone as guarded as myself, having a person you can trust completely to engage with means more to me than I can put into words.",
    author: "Anonymous"
  },
  {
    id: 2,
    text: "Thank you for another exceptional experience. You are beautiful, creative and incredibly skilled. You have the knowledge and confidence that makes every session extraordinary. I feel so lucky to get a chance experiencing you and it's a privilege to be allowed to serve you.",
    author: "Devoted Submissive"
  },
  {
    id: 3,
    text: "From you I learned that submission is about acceptance. Not enduring your dominant wishes, but embracing them. The moment I was on my knees was the first moment I truly surrendered to someone. It was one of the most peaceful moments of my life. You changed me for the better.",
    author: "First Timer"
  }
];

export const socialLinks = [
  { name: "Instagram", href: "https://www.instagram.com/t_rex_monroe" },
  { name: "LoyalFans", href: "https://www.loyalfans.com/t_rexmonroe" },
  { name: "Wishlist", href: "https://throne.com/t-rex_monroe" }
];

export const experienceLevels = [
  "First Time",
  "Beginner",
  "Intermediate",
  "Advanced"
];
